import { Spinner } from "@blueprintjs/core";
import React, { useEffect, useState } from "react";
import { generatePath } from "react-router-dom";
import http from "../../../utils/http";
import { API_BASE_CEAM, ROUTES } from "../../../utils/routes";
import { DeleteConfirmation } from "../../common/DeleteConfirmation";
import TableActionButtons from "../../common/TableActionButtons";
import { TableAdvanced } from "../../common/TableAdvanced";

export const getAllInstitute = async () => {
  try {
    const json = await http.get(`${API_BASE_CEAM}/api/intezmeny`);
    return json;
  } catch (error) {
    console.error(error);
  }
};

const InstituteAll = () => {
  const [institutes, setInstitutes] = useState();
  const [rowToDelete, setRowToDelete] = useState();

  useEffect(() => {
    getAllInstitute().then((data) => setInstitutes(data));
  }, []);

  const handleDelete = async () => {
    const json = await http.del(
      `${API_BASE_CEAM}/api/intezmeny/${rowToDelete.naturalId}`
    );
    setRowToDelete(null);
    getAllInstitute().then((data) => setInstitutes(data));
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "ID",
        accessor: "naturalId",
      },
      {
        Header: "Név",
        accessor: "name",
      },
      {
        Header: "Domain",
        accessor: "realDomains",
        Cell: ({ value }) =>
          value.map((domain) => (
            <a
              key={domain}
              style={{ display: "block" }}
              href={`https://${domain}`}
              target="_blank"
            >
              {domain}
            </a>
          )),
      },
      {
        Header: "EDIR domain",
        accessor: "frontendEdirDomain",
        Cell: ({ value }) => (
          <a href={`https://${value}`} target="_blank">
            {value}
          </a>
        ),
      },
      {
        Header: "SZC",
        accessor: "relatedSzakkepzesCentrum",
        Cell: ({ value }) => value?.name ?? "-",
      },
      {
        Header: "Tag",
        accessor: "tag",
      },

      {
        Header: "Művelet",
        Cell: ({ row }) => (
          <TableActionButtons
            row={row}
            onDelBtnClick={() => setRowToDelete(row.original)}
            editHref={generatePath(ROUTES.edirInstituteEdit, {
              id: row.original.naturalId,
            })}
          />
        ),
      },
    ],
    []
  );

  if (!institutes) return <Spinner />;

  return (
    <>
      <DeleteConfirmation
        isOpen={!!rowToDelete}
        recordName={rowToDelete?.name}
        onDelete={handleDelete}
        onCancel={() => setRowToDelete(null)}
      />

      <h2>Összes EDIR Intézmény</h2>
      <TableAdvanced columns={columns} data={institutes} idField="naturalId" />
    </>
  );
};

export default InstituteAll;
